<template>
  <div class="singIn register">
    <div class="logo">
      <div class="backIcon">
        <i
          class="el-icon-back cursor"
          @click="goBack"></i>
      </div>
      <div class="tvuLogo">
        <!-- <img src="./../assets/img/TVU networks Copy.png" alt=""> -->
      </div>
    </div>
    <div class="formBody">
      <div class="singInLabel">
        <p class="tvuSingIn">{{$t('lang.completeRegist')}}</p>
        <p class="tvuDescribe">{{$t('lang.registInfo')}}</p>
      </div>
      <div class="singInForm">
        <div class="exchange pswArea">
          <el-input
            class="input"
            type="password"
            tabindex='1'
            maxlength="64"
            @input="checkPsd"
            @keyup.enter.native="nextOpaertaion"
            @focus="focusInput('psd')"
            @blur="blurInput"
            v-model="password"
            show-password
            :placeholder="$t('lang.pswFormat')"></el-input>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">{{$t('lang.pswtip')}}</span>
          </div>
        </div>
        <!-- <div class="pswTip" v-show="isShowStrength">
					<div class="pswBox">
						<div v-for="i in 6" :key="i" :class="[i<=strengthNum?'active':'','text']"></div>
					</div>
					<div class="strongTip" >
						<span class="strength">{{$t('lang.pswStrength')}}:</span>
						<span class="length" v-if="strengthNum==2">{{$t('lang.low')}}</span>
						<span class="length" v-else-if="strengthNum==4">{{$t('lang.middle')}}</span>
						<span class="length" v-else-if="strengthNum==6">{{$t('lang.high')}}</span>
					</div>
				</div> -->
        <div class="exchange comfPswArea">
          <el-input
            class="input"
            type="password"
            tabindex='2'
            maxlength="64"
            @keyup.enter.native="nextOpaertaion"
            @focus="focusInput"
            @blur="blurInput"
            v-model="comfirmPassword"
            show-password
            :placeholder="$t('lang.comfirmPsw')"></el-input>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">{{$t('lang.pswInconsist')}}</span>
          </div>
        </div>
        <div class="telphone">
          <vue-tel-input
            class='telInput'
            v-model="phone"
            :placeholder="$t('lang.phonePlacehoder')"
            tabindex='3'
            @open="changeNation"
            @country-changed="changeCountry"
            @validate='validateNum'
            @input="changeTel"
            @blur="blurTel"
            :disabled="!canSend"
            @keyup.enter.native="nextOpaertaion">
            <template slot="arrow-icon">
              <i class='el-icon-arrow-down'></i>
            </template>
          </vue-tel-input>
          <div
            v-if="showSendBtn"
            class='send-code'
            @click='sendCodeRequest'>{{canSend ? $t('lang.sendCode') : timeNum + 's'}}</div>
        </div>
        <div
          class="exchange telphone errorTel"
          style="margin-top: 0">
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">{{$t('lang.enterTelTip')}}</span>
          </div>
        </div>
        <div
          class="exchange verify"
          v-show="showCode">
          <el-input
            class="input"
            type="text"
            tabindex='2'
            maxlength="6"
            minlength="4"
            @keyup.enter.native="nextOpaertaion"
            @focus="focusInput"
            @blur="blurInput"
            v-model="verifyCode"
            :placeholder="$t('lang.verifyCode')"></el-input>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">{{$t('lang.vcodeEror')}}</span>
          </div>
        </div>
        <div class="job">
          <el-select
            v-model="selectedJob"
            popper-class="joblist"
            :filter-method="handleSelect"
            @focus="focusJob"
            filterable
            :placeholder="$t('lang.jobRole')"
            @keyup.enter.native="nextOpaertaion">
            <el-option
              v-for="item in jobList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="confirmArea">
          <el-button
            class="confirmBtn cursor"
            v-repeat-click="{event:nextOpaertaion}"
            :disabled='isDisabeBtn'
            :loading="isLoading">{{$t('lang.done')}}</el-button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
// @ is an alias to /src
const sha512 = require('js-sha512')

export default {
  name: 'CreateAccount',
  data () {
    return {
      email: '111',
      vcode: '',
      password: '',
      comfirmPassword: '',
      isShowStrength: false,
      strengthNum: 0,
      isDisabeBtn: true,
      emailErrorTip: '',
      selectedJob: '',
      selectedNum: '',
      phone: '',
      verfyObj: {},
      isLoading: false,
      canSend: true,
      timeNum: 59,
      timer: null,
      showCode: false,
      verifyCode: '',
      country: null,
      showSendBtn: false
    }
  },
  created () {
    // this.$store.state.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  },
  watch: {
    password: function () {
      // if($('.pswArea').hasClass('errorInput')){
      // 	$('.pswArea').removeClass('errorInput').find(".warning").addClass('info');
      // }
      if (!this.password || !this.comfirmPassword || !this.selectedJob || !this.phone || (this.country == '86' && !this.verifyCode)) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
      // if(newVal){
      // 	this.isShowStrength = true;
      // 	this.strengthNum = this.checkPassWord(newVal);
      // }else{
      // 	this.strengthNum = 0;
      // 	this.isShowStrength = false;
      // }
    },
    comfirmPassword: function () {
      if ($('.comfPswArea').hasClass('errorInput')) {
        $('.comfPswArea').removeClass('errorInput')
      }
      if (!this.password || !this.comfirmPassword || !this.selectedJob || !this.phone || (this.country == '86' && !this.verifyCode)) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    },
    phone: function () {
      if ($('.telphone').hasClass('errorInput')) {
        $('.telphone').removeClass('errorInput')
      }
      if (!this.password || !this.comfirmPassword || !this.selectedJob || !this.phone || (this.country == '86' && !this.verifyCode)) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    },
    selectedJob: function () {
      if (!this.password || !this.comfirmPassword || !this.selectedJob || !this.phone || (this.country == '86' && !this.verifyCode)) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    },
    verifyCode: function () {
      if (!this.password || !this.comfirmPassword || !this.selectedJob || !this.phone || (this.country == '86' && !this.verifyCode)) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    },
    country: function () {
      if (!this.password || !this.comfirmPassword || !this.selectedJob || !this.phone || (this.country == '86' && !this.verifyCode)) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    },
    location () {
      return this.$store.state.location
    },
    urlHref () {
      return this.$store.state.href
    },
    jobList () {
      return [
        {
          value: 'Owner/CEO/President',
          label: this.$t('lang.owner')
        },
        {
          value: 'COO/Operation/Finance',
          label: this.$t('lang.coo')
        },
        {
          value: 'CTO/Engineer/Developer/IT Lead',
          label: this.$t('lang.cto')
        },
        {
          value: 'Director/Manager',
          label: this.$t('lang.director')
        },
        {
          value: 'Markeing/Communications Lead',
          label: this.$t('lang.marketing')
        },
        {
          value: 'Strategy/Bussiness Development',
          label: this.$t('lang.strategy')
        },
        {
          value: 'Producer/Editor',
          label: this.$t('lang.producer')
        },
        {
          value: 'Student/Teacher',
          label: this.$t('lang.student')
        },
        {
          value: 'Consultant',
          label: this.$t('lang.consult')
        },
        {
          value: 'Other',
          label: this.$t('lang.other')
        }
      ]
    }
  },
  methods: {
    sendCodeRequest () {
      if (!this.canSend) return
      this.axios.post(
        '/userGroup/user-group/login/sendMsgCode',
        {
          userId: this.userInfo !== null && this.userInfo !== undefined ? this.userInfo.id : '',
          phone: this.phone.replace(/\s*/g, '')
        },
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.$message({
            message: this.$t('lang.sendSuccess'),
            type: 'success',
            duration: 1500
          })
          this.sendCodeChange()
        } else if (res.data.errorCode == '80945301') {
          this.$message({
            message: this.$t('lang.error80945301'),
            type: 'error',
            duration: 3000
          })
        } else if (res.data.errorCode == '80943201') {
          this.$message({
            message: this.$t('lang.error80943201'),
            type: 'error',
            duration: 3000
          })
        } else {
          this.$message({
            message: res.data.errorInfo,
            type: 'error',
            duration: 3000
          })
        }
      }).catch(() => {
      })
    },
    sendCodeChange () {
      this.showCode = true
      this.canSend = false
      this.timeNum = 59
      this.timer = setInterval(() => {
        this.timeNum--
        if (this.timeNum == 0) {
          clearInterval(this.timer)
          this.canSend = true
        }
      }, 1000)
    },
    changeNation () {
      // if (!this.verfyObj.valid) {
      //   $('.telphone').addClass('errorInput')
      // } else {
      //   $('.telphone').removeClass('errorInput')
      // }
      this.blurTel()
      $('.vti__dropdown-item .hk').parent().remove()
      // $('.vti__dropdown-item .tw').next().html('Taiwan,China (中国台湾)')
      $('.vti__dropdown-item .tw').parent().remove()
      $('.vti__dropdown-item .mo').parent().remove()
      // 隐藏黑名单国家 Cuba,North Korea,Syria
      $('.vti__dropdown-item .cu').parent().remove()
      $('.vti__dropdown-item .sy').parent().remove()
      $('.vti__dropdown-item .kp').parent().remove()
    },
    focusJob () {
      // alert(111)
      $('.joblist').css('display', 'none')
    },
    handleSelect (item) {
      // ga('send', 'event', 'newUserService-register-changeJob', 'click')
      gtag('event', 'newUserService-register-changeJob')
      this.selectedJob = item
    },
    checkPassWord (value) {
      // 0： 表示第一个级别 1：表示第二个级别 2：表示第三个级别
      // 3： 表示第四个级别 4：表示第五个级别
      let modes = 0

      if (value.length < 6) { // 最初级别
        return 2
      }
      if (/\d/.test(value)) { // 如果用户输入的密码 包含了数字
        modes++
      }
      if (/[a-z]/.test(value)) { // 如果用户输入的密码 包含了小写的a到z
        modes++
      }
      if (/[A-Z]/.test(value)) { // 如果用户输入的密码 包含了大写的A到Z
        modes++
      }
      if (/\W/.test(value)) { // 如果是非数字 字母 下划线
        modes++
      }
      switch (modes) {
        case 1:
          return 2
        case 2:
          return 4
        case 3:
          return 6
        case 4:
          return 6
      }
    },
    goBack () {
      // ga('send', 'event', 'newUserService-register-goBack', 'click')
      gtag('event', 'newUserService-register-goBack')
      this.$router.go(-1)
    },
    nextOpaertaion () {
      // ga('send', 'event', 'newUserService-register-register', 'click')
      gtag('event', 'newUserService-register-register')
      if (this.isLoading) {
        return
      }
      if (!this.checkPsd(this.password)) {
        $('.pswArea').addClass('errorInput').find('.warning').removeClass('info')
        return
      }
      if (this.password != this.comfirmPassword) {
        $('.comfPswArea').addClass('errorInput')
        return
      }
      // const reg = /^([\w+.-]*[+-]*\.*)+@(\w-?)+(\.\w{2,})+$/
      if (this.country == '86') {
        const phone = this.phone.replace(/\s*/g, '')
        if (!(/^1[0-9]{10}$/.test(phone))) {
          $('.telphone').addClass('errorInput')
          return
        }
      } else {
        if (!this.verfyObj.valid) {
          $('.telphone').addClass('errorInput')
          return
        }
      }
      if (this.password.length < 8) {
        this.$message({
          message: this.$t('lang.pswtip'),
          type: 'error',
          duration: 3000
        })
        return
      }
      if (this.country == '86' && this.verifyCode.length != 6) {
        $('.verify').addClass('errorInput')
        return
      }
      this.isLoading = true
      let params = {
        userId: this.userInfo !== null && this.userInfo !== undefined ? this.userInfo.id : '',
        password: sha512(this.password),
        confirmPassword: sha512(this.comfirmPassword),
        phone: this.phone.replace(/\s*/g, ''),
        jobTitle: this.selectedJob
      }
      if (this.country == '86') {
        params.verifyCode = this.verifyCode
      }
      this.axios.post(
        '/userGroup/user-group/login/complete',
        this.qs.stringify(params),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      ).then((res) => {
        // if(res.data.errorCode == '0x0'){
        // 注册成功
        this.isLoading = false
        if (res.data.errorCode == '0x0') {
          // let href = window.location.href;
          // let params;
          // if(href.includes('?')){
          // 	params = decodeURIComponent(href).split('?')[1].split('&');
          // }else{
          // 	if(this.urlHref.includes('?')){
          // 		params = decodeURIComponent(this.urlHref).split('?')[1].split('&');
          // 	}else{
          // 		this.$router.push({path: '/'});
          // 		return;
          // 	}
          // }
          // let url,serviceName;
          // params.forEach(item=>{
          // 	if(item.includes('url=')){
          // 		url = item.split('url=')[1];
          // 	}else if(item.includes('serviceName=')){
          // 		serviceName = item.split('serviceName=')[1];
          // 	}
          // })
          // if(url){
          // 	this.$router.push({path: '/', query: {url: url,serviceName:serviceName}});
          // }else{
          // this.$router.push({ path: '/' })
          // }

          // window.location.href = this.location;
          // 移动端注册账号成功后跳转到登录页需要url上的type
          const flag = this.urlHref.includes('type=')
          if (flag) {
            const url = '/signIn?' + this.urlHref.split('?')[1]
            this.$router.push({ path: url })
          } else {
            this.$router.push({ path: '/' })
          }
        } else if (res.data.errorCode == '80943301') {
          this.$message({
            message: this.$t('lang.error80943401'),
            type: 'error',
            duration: 3000
          })
        } else if (res.data.errorCode == '80943302') {
          this.$message({
            message: this.$t('lang.error80943003'),
            type: 'error',
            duration: 3000
          })
        } else if (res.data.errorCode == '80943303') {
          this.$message({
            message: this.$t('lang.error80943503'),
            type: 'error',
            duration: 3000
          })
        } else if (res.data.errorCode == '80943304') {
          this.$message({
            message: this.$t('lang.verifyError'),
            type: 'error',
            duration: 3000
          })
        } else {
          this.$message({
            message: res.data.errorInfo,
            type: 'error',
            duration: 3000
          })
        }
      }).catch(() => {
        this.isLoading = false
      })
    },
    focusInput (event) {
      if (event && event == 'psd') {
        if (!this.checkPsd(this.password) && !$('.pswArea').hasClass('errorInput')) {
          $('.pswArea').removeClass('errorInput').find('.warning').addClass('info')
          $('.pswArea').find('.tip').css({
            display: 'inline-block',
            color: 'rgba(51,171,79,1)'
          })
        }
      } else {
        $(event.target).parent().prev('.tip').css({
          display: 'inline-block',
          color: 'rgba(51,171,79,1)'
        })
      }
    },
    blurInput (event) {
      $(event.target).parent().prev('.tip').css('color', 'rgba(153,153,153,1)')
    },
    checkPsd (val) {
      const reUpper = /[A-Z]/
      const reLower = /[a-z]/
      const reNum = /[0-9]/
      const reLen = /^.{8,64}$/
      const patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im
      // str = new RegExp("[`~!@#$^&*()+=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——_|{}【】‘；：”“'。，、？ ]"),
      // str = new RegExp("/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im");

      let count = 0

      if (reLower.test(val)) {
        ++count
      }
      if (reUpper.test(val)) {
        ++count
      }
      if (reNum.test(val)) {
        ++count
      }
      if (patrn.test(val)) {
        ++count
      }
      if (reLen.test(val)) {
        ++count
      }
      if (count == 5) {
        $('.pswArea').removeClass('errorInput').find('.warning').removeClass('info')
        return true
      }
      if ($('.pswArea').hasClass('errorInput')) {
        $('.pswArea').find('.warning').removeClass('info')
      } else {
        $('.pswArea').find('.warning').addClass('info')
      }
      return false
    },
    validateNum (obj) {
      this.verfyObj = obj
    },
    changeTel () {
      if (this.country != '86') return
      // 手机号码验证正确才显示发送验证码
      const phone = this.phone.replace(/\s*/g, '')
      if (!(/^1[0-9]{10}$/.test(phone))) {
        this.showSendBtn = false
      } else {
        this.showSendBtn = true
      }
    },
    blurTel () {
      if (this.country == '86') {
        const phone = this.phone.replace(/\s*/g, '')
        if (!(/^1[0-9]{10}$/.test(phone))) {
          $('.telphone').addClass('errorInput')
        } else {
          $('.telphone').removeClass('errorInput')
        }
      } else {
        if (this.phone && !this.verfyObj.valid) {
          $('.telphone').addClass('errorInput')
        } else {
          $('.telphone').removeClass('errorInput')
        }
      }
    },
    changeCountry (country) {
      // 被删除的国家和地方显示US
      if (country.iso2 == 'HK' || country.iso2 == 'TW' || country.iso2 == 'MO' || country.iso2 == 'CU' || country.iso2 == 'SY' || country.iso2 == 'KP') {
        country.dialCode = '1'
        const delClass = (country.iso2).toLowerCase()
        this.$nextTick(() => {
          $('.vti__selection .vti__flag').removeClass(delClass).addClass('us')
        })
      }
      this.country = country.dialCode
      this.showSendBtn = false
      this.showCode = false
      // ga('send', 'event', 'newUserService-register-changeCountry', 'click')
      gtag('event', 'newUserService-register-changeCountry')
      if (Object.keys(this.verfyObj).length == 0) {
        return
      }
      this.blurTel()
      this.changeTel()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (to.query && to.query.userId) {
        vm.$store.state.userInfo.id = to.query.userId
      } else {
        vm.$store.state.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      }
    })
  },
  filters: {
    getStrength (val) {
      switch (val) {
        case 2:
          return this.$t('lang.low')
        case 4:
          return this.$t('lang.middle')
        case 6:
          return this.$t('lang.high')
        default:
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.warning {
  &.info {
    display: inline-block !important;
    .warningTip {
      color: #505050 !important;
    }
    .el-icon-warning-outline {
      color: #505050 !important;
    }
  }
}
.telInput {
  width: 100%;
  height: 50px!important;
}
.telphone {
  position: relative;
  .send-code {
    min-width: 35px;
    position: absolute;
    right: 15px;
    color: #33ab4f;
    top: 14px;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
